var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$attrs.class, 'social-links', `social-links--shape--${_vm.shape}`]},[_c('ul',{staticClass:"social-links__list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.type,staticClass:"social-links__item"},[_c('a',{class:[
          'social-links__link',
          `social-links__link--type--${item.type}`,
        ],attrs:{"href":item.url,"target":"_blank"}},[_c('i',{class:item.icon})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }